import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2"; 
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import ModalPrecertificado from "../components/PrecertificadoCE/ModalFormularioPrecetificado";

const rx_live = /^(\$|)([0]?||[1-9]\d{0,2}(\d{3})*|([1-9]\d*))(\.\d{0,2})?$/; // /^([0-9]{1,3}?|[0-9]?)(?:[.,]\d*)?$/;
const entero = /^[1-9]\d*$/; // /^([1-9])|[1-9][0-9]\d*$/; //enteros positivos mayor a cero
const entero_a = /^([0-9]\d*)?$/;

class PrecertificadosCE extends React.Component {
  initialState = {
    openModal: false,
    buscarPrecertificado: {},
    establecimiento_id: "",
    tipos_subproductos: Api.loadCatalogue("cat_subproducto_tipo"),
    subproducto_tipo_id: "",
    productos: [],
    producto_id: "",
    presentaciones: [],
    presentacion_id: "",
    cantidad: "",
    peso_neto: "",
    no_lote: "",
    codigo_produccion: "",
    fabricante: "",
    fabricante_id: "",
    descripcion_producto: "",
    razon_social: "",
    guid: "",
    aux_tipo_subproducto: "",
    nombre: "",
    direccion: "",
    nombre_final: "",
    direccion_final: "",
    no_contenedor: "",
    no_marchamo: "",
    fecha: new Date().toISOString().slice(0, 10),
    puerto_salida: "",
    puerto_entrada: "",
    compania_transportadora: "",
    medio_transportes: Api.loadCatalogue("cat_tipo_vehiculo"),
    medio_transporte_id: "",
    identificacion_transporte: "",
    //observaciones: "",
    estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
    establecimiento: {
      id: "",
      razon_social: "",
      guid: "",
    },
    establecimiento_exportador: {
      id: "",
      razon_social: "",
      guid: "",
    },
    actividades: [5, 23], //exportador
    tipo_documentos: [],
    tipo_documento_id: "",
    documentos: [],
    documento: [],
    previa: false,
    previa_url: "",
    registros_docs: 0,
    disable_establecimiento: false,
    cantidad_disponible: "",
    solicitud_id: "",
    folio_solicitud: "",
  };

  constructor(props) {
    super(props);

    this.handleCompaniaTransportadoraChange =
      this.handleCompaniaTransportadoraChange.bind(this);
    this.handleCodigoProduccionChange =
      this.handleCodigoProduccionChange.bind(this);
    this.handleExisteEstablecimiento =
      this.handleExisteEstablecimiento.bind(this);
    this.handleChangeDireccionFinal =
      this.handleChangeDireccionFinal.bind(this);
    this.handleIdentificacionChange =
      this.handleIdentificacionChange.bind(this);
    this.handlePuertoEntradaChange = this.handlePuertoEntradaChange.bind(this);
    this.handleNoContenerdorChange = this.handleNoContenerdorChange.bind(this);
    this.handleNoContenerdorChange = this.handleNoContenerdorChange.bind(this);
    this.handleGuidEstablecimiento = this.handleGuidEstablecimiento.bind(this);
    this.handleChangeTipoDocumento = this.handleChangeTipoDocumento.bind(this);
    this.handlePuertoSalidaChange = this.handlePuertoSalidaChange.bind(this);
    this.handleChangePresentacion = this.handleChangePresentacion.bind(this);
    this.handleChangeSubproducto = this.handleChangeSubproducto.bind(this);
    this.handleDescripcionChange = this.handleDescripcionChange.bind(this);
    this.handleRazonSocialChange = this.handleRazonSocialChange.bind(this);
    //this.handleObservacionChange = this.handleObservacionChange.bind(this);
    this.handleChangeNombreFinal = this.handleChangeNombreFinal.bind(this);
    this.handleCloseVistaPrevia = this.handleCloseVistaPrevia.bind(this);
    this.handleChangeDireccion = this.handleChangeDireccion.bind(this);
    this.handleEstablecimiento = this.handleEstablecimiento.bind(this);
    this.handleChangeProducto = this.handleChangeProducto.bind(this);
    this.handleCantidadChange = this.handleCantidadChange.bind(this);
    this.handlePesoNetoChange = this.handlePesoNetoChange.bind(this);
    this.handleNoLoteChange = this.handleNoLoteChange.bind(this);
    this.handleChangeNombre = this.handleChangeNombre.bind(this);
    this.handleVistaPrevia = this.handleVistaPrevia.bind(this);
    this.handleChangeFecha = this.handleChangeFecha.bind(this);
    this.handleMedioChange = this.handleMedioChange.bind(this);
    this.handleGuidChange = this.handleGuidChange.bind(this);
    this.removeDocumento = this.removeDocumento.bind(this);
    this.handleFile = this.handleFile.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.OpenModal = this.OpenModal.bind(this);

    this.state = this.initialState;
  }

  mi_grid = {};
  componentDidMount() {
    let grid = {
      source: "app/getPrecertificadoCE",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "Folio Solicitud",
        },
        razon_social: {
          label: "Razón Social",
          render: (me) => {
            if (
              me.data.razon_social !== null ||
              me.data.razon_social !== undefined
            ) {
              me.innerHTML = me.data.razon_social;
            } else {
              me.innerHTML = "";
            }
          },
        },
        cantidad: {
          label: "Cantidad solicitada",
          render: (me) => {
            if (me.data.cantidad !== null || me.data.cantidad !== undefined) {
              me.innerHTML = me.data.cantidad;
            } else {
              me.innerHTML = "";
            }
          },
        },
        cantidad_disponible: {
          label: "Cantidad disponible",
          render: (me) => {
            if (
              me.data.cantidad_disponible !== null ||
              me.data.cantidad_disponible !== undefined
            ) {
              me.innerHTML = me.data.cantidad_disponible;
            } else {
              me.innerHTML = "";
            }
          },
        },
        fecha_solicitud: {
          label: "Fecha Solicitud",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        descripcion: {
          label: "Estado",
          render: (me) => {
            if (
              me.data.estatus_tramite_id === 9 ||
              me.data.estatus_tramite_id === 10
            ) {
              me.innerHTML = "En espera";
            } else if (
              me.data.estatus_tramite_id === 3 &&
              me.data.cantidad_disponible > 0
            ) {
              me.innerHTML = "Llenar ";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            this.OpenModal(data);
          },
          render: (me, data) => {
            if (data.cantidad_disponible < 1) {
              me.remove();
            }
          },
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio",
            placeHolder: "Ingresa el folio de la solicitud",
            cols: 4,
          },
        },
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Razón social",
            placeHolder: "Ingresa la razón social del establecimiento",
            cols: 4,
          },
        },
        {
          input: {
            type: "number",
            name: "cantidad",
            label: "Cantidad",
            placeHolder: "Ingresa la cantidad de precertificados y/o ...",
            min: "0",
            cols: 4,
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus",
            label: "Estado",
            placeHolder: "Estado",
            cols: 4,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              let array_mostrar = [3,4,5,9,10];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      if(s.id == 3){
                        s.descripcion = "Llenar"
                      }
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarPrecertificado: busqueda.data() });
              let search = this.state.buscarPrecertificado;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  handleChangeSubproducto(e) {
    this.setState({ subproducto_tipo_id: e.target.value });

    if (e.target.value !== 4) {
      //no tiene destino final
      this.setState({ aux_tipo_subproducto: "consignatario" });
    } else {
      this.setState({ aux_tipo_subproducto: "importador" });
    }
  }

  handleChangeProducto(e) {
    this.setState({ producto_id: e.target.value });

    //bucar el fabricante
    Api.fetch(
      "app/getEstablecimientoFabricanteProducto?producto_id=" + e.target.value
    ).then((response) => {
      if (response) {
        this.setState({
          fabricante: response.razon_social,
          fabricante_id: response.id,
        });
      }
    });

    //buscar precentaciones
    Api.fetch("app/getProductPresentation?producto_id=" + e.target.value).then(
      (response) => {
        if (response) {
          this.setState({ presentaciones: response });
        }
      }
    );
  }

  handleChangePresentacion(e) {
    this.setState({ presentacion_id: e.target.value });
  }

  handleCantidadChange(e) {
    if (e.target.value === "" || entero.test(e.target.value)) {
      this.setState({ cantidad: e.target.value });
    }
  }

  handlePesoNetoChange(e) {
    if (rx_live.test(e.target.value))
      this.setState({ peso_neto: e.target.value });
  }

  handleNoLoteChange(e) {
    // let no_lote = e.target.validity.valid ? e.target.value : this.state.no_lote;
    this.setState({ no_lote: e.target.value });
  }

  handleCodigoProduccionChange(e) {
    this.setState({ codigo_produccion: e.target.value });
  }

  handleDescripcionChange(e) {
    this.setState({ descripcion_producto: e.target.value.toUpperCase() });
  }

  handleRazonSocialChange(e) {
    this.setState({ razon_social: e.target.value.toUpperCase() });
  }

  handleGuidChange(e) {
    this.setState({ guid: e.target.value.toUpperCase() });
  }

  handleEstablecimiento(e) {
    let est = { ...this.state.establecimiento };
    est[e.target.name] = e.target.value.toUpperCase();
    this.setState({ establecimiento: est });
  }

  handleGuidEstablecimiento(e) {
    if (this.state.establecimiento_exportador.id === "") {
      let est = {
        razon_social: this.state.establecimiento.razon_social,
        guid: this.state.establecimiento.guid,
      };

      if (est.razon_social === "" || est.guid === "") {
        return;
      }

      Api.fetch("app/getValidEstablishmentByGUID", est, "POST").then((data) =>
        this.handleExisteEstablecimiento(est, data)
      );
    }
  }

  handleExisteEstablecimiento(est, data) {
    if (data.id) {
      let est_id = data.id;
      //checar si el establecimiento esta viegente y tiene licencia activa
      Api.fetch(
        "app/getActividadesEstablecimiento?establecimiento_id=" + est_id
      ).then((data) => {
        if (data) {
          data.forEach((act) => {
            if (this.state.actividades.includes(parseInt(act.id))) {
              this.setState({ disable_establecimiento: true });
              let adr = document.querySelector("#addEst");
              adr.classList = "btn btn-success";
              document.querySelector("#addEst i").classList = "fas fa-check";

              let establecimiento = { ...this.state.establecimiento };
              let establecimiento_exportador = {
                ...this.state.establecimiento_exportador,
              };

              let est = {
                razon_social: establecimiento["razon_social"],
                guid: establecimiento["guid"],
                id: est_id,
              };

              /*  adr.addEventListener("click", (e) => {
                //cuando vuelva a dar click va a limpiar los campos
                if (est.razon_social !== "" && est.guid !== "") {
                  adr.classList = "btn btn-light";
                  document.querySelector("#addEst i").classList = "fa fa-th";
                  this.setState({ disable_establecimiento: false });

                  establecimiento["razon_social"] = "";
                  establecimiento["guid"] = "";

                  this.setState({
                    establecimiento: establecimiento,
                  });
                }

                if (adr.classList === "btn btn-light") {
                  return;
                }
              }); */

              //campos estan vacios entonces no agregamos
              if (est.razon_social !== "" && est.guid !== "") {
                establecimiento_exportador["id"] = est.id;
                establecimiento_exportador["razon_social"] = est.razon_social;
                establecimiento_exportador["guid"] = est.guid;

                this.setState({
                  establecimiento_exportador: establecimiento_exportador,
                  establecimiento: establecimiento,
                });
              }
            }
          });
        }
      });
    } else {
      Swal.fire({
        title: "Error al ingresar el establecimiento",
        icon: "warning",
        text: "Favor de ingresar un establecimiento con licencia vigente.",
      });
    }
  }

  handleNoContenerdorChange(e) {
    if(entero_a.test(e.target.value))
      this.setState({ no_contenedor: e.target.value });
  }

  handleNoMarchamoChange(e) {
    //if(entero_a.test(e.target.value))
    this.setState({ no_marchamo: e.target.value });
  }

  handleChangeFecha(e) {
    this.setState({ fecha: e.target.value });
  }

  handlePuertoSalidaChange(e) {
    this.setState({ puerto_salida: e.target.value.toUpperCase() });
  }

  handlePuertoEntradaChange(e) {
    this.setState({ puerto_entrada: e.target.value.toUpperCase() });
  }

  handleCompaniaTransportadoraChange(e) {
    this.setState({ compania_transportadora: e.target.value.toUpperCase() });
  }

  handleMedioChange(e) {
    this.setState({ medio_transporte_id: e.target.value });
  }

  handleIdentificacionChange(e) {
    this.setState({ identificacion_transporte: e.target.value.toUpperCase() });
  }

  /* handleObservacionChange(e) {
    this.setState({ observaciones: e.target.value.toUpperCase() });
  }*/

  handleChangeNombre(e) {
    this.setState({ nombre: e.target.value.toUpperCase() });
  }

  handleChangeDireccion(e) {
    this.setState({ direccion: e.target.value.toUpperCase() });
  }

  handleChangeNombreFinal(e) {
    this.setState({ nombre_final: e.target.value.toUpperCase() });
  }

  handleChangeDireccionFinal(e) {
    this.setState({ direccion_final: e.target.value.toUpperCase() });
  }

  handleVistaPrevia(e) {
    let file = this.state.documentos[e.target.id].data;
    file = file.substr("data:application/pdf;base64,".length);
    this.setState({ previa: true, previa_url: file });
  }

  handleCloseVistaPrevia(e) {
    this.setState({ previa: false });
  }

  handleChangeTipoDocumento(e) {
    this.setState({ tipo_documento_id: e.target.value });
  }

  handleFile(e) {
    let file = e.files[0];
    /**
     * file
     * name: "REF-004-21.pdf"
     * size: 2356
     * type: "application/pdf"
     * webkitRelativePath: ""
     */
    let ext = file.type.split("/")[1];
    let carga = [];
    var reader = new FileReader();

    let nom_tdocumento = "";
    for (let i in this.state.tipo_documentos) {
      if (this.state.tipo_documentos[i].id === this.state.tipo_documento_id) {
        nom_tdocumento = this.state.tipo_documentos[i].descripcion;
        break;
      }
    }

    let data = {
      nombre: file.name,
      type: ext,
      archivo: e.name,
      tipo_documento_id: this.state.tipo_documento_id,
      tipo_documento: nom_tdocumento,
    };

    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.data = reader.result;
      };
      carga.push(data);
    }

    this.addDocument(carga);
  }

  addDocument(documento) {
    let doc = documento[0];
    let pa = [...this.state.documentos];

    for (let i in this.state.documentos) {
      if (pa[i].nombre === doc.nombre) {
        Swal.fire({
          title: "Atención",
          text: "Ya cuenta con este documento en su lista.",
        });
        return;
      }
    }

    pa.push(doc);
    this.setState({
      documentos: pa,
    });

    //tengo que quitar el documento del select
    let lista = [...this.state.tipo_documentos];
    for (let i in this.state.tipo_documentos) {
      if (lista[i].id === doc.tipo_documento_id) {
        lista.splice(parseInt(i), 1);
        break;
      }
    }
    this.setState({ tipo_documentos: lista });
  }

  removeDocumento(e) {
    let id = e.target.getAttribute("data-tipo_documento_id");
    let descripcion = e.target.getAttribute("data-descripcion");

    let lista = [...this.state.documentos];
    lista.splice(e.target.id, 1);
    this.setState({ documentos: lista });

    //agregamos de nuevo en el select
    let array = [];
    let obj_tipo_documento = {
      id: id,
      descripcion: descripcion,
    };

    array.push(obj_tipo_documento);
    this.setState({ tipo_documentos: array });
  }

  OpenModal(data) {
    //Buscamos todos los productos del establecimiento
    Api.fetch(
      "app/getProductosEstablecimientoSubproducto?establecimiento_id=" +
        data.establecimiento_id
    ).then((response) => {
      if (response) {
        this.setState({ productos: response });
      }

      Api.fetch("app/getDocumentoObligatorioPCE").then((docs) => {
        if (docs) {
          this.setState({ tipo_documentos: docs, registros_docs: docs.length });
        }
      });

      this.setState({
        openModal: true,
        establecimiento_id: data.establecimiento_id,
        cantidad_disponible: data.cantidad_disponible,
        solicitud_id: data.solicitud_id,
        folio_solicitud: data.folio_solicitud,
      });
    });
  }

  closeModal() {
    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModal: false });
        this.resetStates();
      }
    });
  }

  resetStates = () => {
    this.setState({ ...this.initialState });
  };

  handleSubmit(e) {
    e.preventDefault();
    let valido = 1;
    if (this.state.registros_docs > 0 && this.state.documentos.length === 0) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar los documentos correspondientes.",
      });
      valido = 0;
    }

    if (this.state.establecimiento_exportador.id === "") {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar el establecimiento exportador correcto.",
      });
      valido = 0;
    }

    if (
      this.state.subproducto_tipo_id === "" ||
      this.state.producto_id === "" ||
      this.state.presentacion_id === "" ||
      this.state.cantidad === "" ||
      this.state.peso_neto === "" ||
      this.state.no_lote === "" ||
      this.state.codigo_produccion === "" ||
      this.state.descripcion_producto === "" ||
      this.state.nombre === "" ||
      this.state.direccion === "" ||
      this.state.no_contenedor === "" ||
      this.state.puerto_salida === "" ||
      this.state.puerto_entrada === "" ||
      this.state.compania_transportadora === "" ||
      this.state.medio_transporte_id === "" ||
      this.state.identificacion_transporte === ""
    ) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor revisar el formulario.",
      });
      valido = 0;
    }

    if (
      this.state.subproducto_tipo_id !== 4 &&
      (this.state.nombre_final === "" || this.state.direccion_final === "")
    ) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor revisar el formulario.",
      });
      valido = 0;
    }

    if (valido) {
      Swal.fire({
        title:
          "¿Seguro que desea realizar la solicitud? Le quedarán " +
          (parseInt(this.state.cantidad_disponible) - 1) +
          " disponibles.",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          /**creo el objeto que le voy a enviar */
          let subproducto = { ...this.state };
          delete subproducto.openModal;
          delete subproducto.buscarPrecertificado;
          delete subproducto.establecimiento_id;
          delete subproducto.tipos_subproductos;
          delete subproducto.productos;
          delete subproducto.presentaciones;
          delete subproducto.aux_tipo_subproducto;
          delete subproducto.estatusTramiteCombo;
          delete subproducto.establecimiento;
          delete subproducto.guid;
          delete subproducto.razon_social;
          delete subproducto.actividades;
          delete subproducto.tipo_documentos;
          delete subproducto.tipo_documento_id;
          delete subproducto.documento;
          delete subproducto.previa;
          delete subproducto.previa_url;
          delete subproducto.registros_docs;
          delete subproducto.disable_establecimiento;
          delete subproducto.medio_transportes;

          Api.loading(true);
          Api.fetch(
            "app/generarSolicitudPrecertificadoCE",
            subproducto,
            "POST"
          ).then((data) => {
            Api.loading(false);
            Swal.fire({
              icon: "success",
              title: data.message,
              timer: 3000,
            }).then(() => {
              this.mi_grid.go(1);
              this.setState({ openModal: false });
              this.setState({ ...this.initialState });
            });
          });
        }
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/subproductos/precertificado-constancia-exportacion">Subproductos</Link>
          </li>
          <li className="breadcrumb-item active">
            Precertificados y/o constancias de exportación
          </li>
        </ol>
        <h1 className="page-header">
          Precertificados y/o constancias de exportación
        </h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <Modal
          isOpen={this.state.openModal}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModal();
            }}
            className="text-center"
          >
            Formulario precertificado y/o constancia de exportación:{" "}
            {this.state.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={this.handleSubmit}>
              <ModalPrecertificado
                key={this.state.producto_id}
                component={this}
                state={this.state}
              />
            </form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default PrecertificadosCE;
